import { Injectable } from '@angular/core';
import { Parser } from 'json2csv';

// Ref: https://github.com/zemirco/json2csv
// https://medium.com/@danny.pule/export-json-to-csv-file-using-javascript-a0b7bc5b00d2
@Injectable()
export class CsvService {
    public export(fieldDefs: any[], data: any, ret: string, fileName: string): void {
        const parser = new Parser({ fields: fieldDefs, withBOM: true, delimiter: ';' });
        let csvData = parser.parse(data, { fields: fieldDefs });
        // csvData = fieldDefs.join(";") + "\n" + data.join(";");
        csvData = ret;
        this.sendToClient(csvData, fileName);
    }

    private sendToClient(csvData: any, fileName: string): void {
        const a: any = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        const blob = new Blob([csvData], { type: 'text/csv;harset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        a.href = url;

        const isIE = /*@cc_on!@*/false || !!(document as any).documentMode;

        if (isIE) {
            const retVal = navigator.msSaveBlob(blob, fileName);
        }
        else {
            a.download = fileName;
        }
        // If you will any error in a.download then dont worry about this.
        a.click();
    }
}
